import FocusedSkuDistribution from './FocusedSkuDistribution';

export default FocusedSkuDistribution;
